<template>
  <div class="not">
    <headd :mobile_title="mobile_title"></headd>
    <div class="kv">
      <img src="../../../static/message/kv.png" />
    </div>
    <div class="notice container">
      <div class="notice_list">
        <div
          class="notice-item"
          v-for="(item, index) in noticeList"
          :key="item.id"
          :data-index="index"
          @click="golink(item.linkUrl, item.actiontype)"
        >
          <div class="item-style-1">
            <div class="item-head" v-if="item.title">
              <div class="head-title">
                {{ item.title }}
                <div class="head-time">{{ item.createdAt }}</div>
              </div>

              <div
                class="item-footer"
                v-if="item.actiontype"
                @click="golink(item.linkUrl, item.actiontype)"
              >
                <div>
                  查看详情
                </div>
                <img src="../../../static/notice/more.png" />
              </div>
            </div>
            <div class="item-content">
              <img v-if="item.imgUrl" :src="item.imgUrl" mode="widthFix" />
              <div class="text" v-if="item.text" v-html="item.text"></div>
            </div>
          </div>
        </div>
      </div>
      <div
        style="margin:0.5rem auto;font-size:0.24rem;"
        @click="morelist"
        v-show="!flag"
      >
        加载更多
      </div>
    </div>
    <foot></foot>
  </div>
</template>

<script>
import { getznnews } from "../api/api"; //引入api里面定义的方法
import headd from "@/components/head";
import foot from "@/components/foot";
export default {
  data() {
    return {
      mobile_title: "通知",
      noticeList: [],
      pageindex: 1,
      flag: false
    };
  },
  metaInfo: {
    title: "马上创业网 专注企业注册的网站", // set a title
    meta: [
      {
        // set meta
        name: "keyWords",
        content:
          "马上创业网，注册公司，代理记账，上海注册公司，注册公司流程，注册公司费用，商标注册，法务咨询，法律服务，个体工商户注册，许可证办理，专业法律，社保，公积金，专利申请，医疗器械许可证，ICP电信增值许可证，食品经营许可证，酒类经营许可证，餐饮服务许可证，道路运输许可证，广播电视节目许可证，海关资质，进出口许可证，商标设计，logo设计，VI设计，海报设计，包装设计，APP开发，微信运营，网站定制，版权服务，软件著作权，发明专利，外观设计专利，实用新型专利，商标转让，驳回复审，注销公司，股权变更，经营范围变更，股权协议，股权转让，劳务派遣"
      },
      {
        name: "description",
        content:
          "马上创业网是一个专为中小企业服务的综合平台，主要提供医疗器械服务、审计服务、知识产权服务、财税咨询、注册公司、代理记账、商标注册、专利申请、社保代理、法务代理等一站式的服务，借助移动互联网技术，改善并升级企业服务状态，实现了新形势下中小企业所需要的企业服务。"
      }
    ]
  },
  components: {
    headd,
    foot
  },
  mounted() {
    this.getnotices();
  },
  methods: {
    async getnotices() {
      var _slef = this;
      var data = {
        uid: localStorage.getItem("userId"),
        page: _slef.pageindex,
        limit: 30
        //limit: 5,
      };
      const res = await getznnews(data);
      //console.log(res)
      //_slef.noticeList = res.data.data.znnews

      _slef.noticeList = _slef.noticeList.concat(res.data.data.znnews);

      if (res.data.data.znnews.length < 30) {
        _slef.flag = true;
      }
    },
    golink(url, actiontype) {
      if (url) {
        if (actiontype == "page") {
          window.open(url, "_self");
        } else {
          window.open(url, "_blank");
        }
      }
    },
    morelist() {
      if (!this.flag) {
        this.pageindex++;
        this.getnotices();
      }
    }
  }
};
</script>

<style lang="less" scoped>
.not {
}
.kv {
  width: 100%;
  margin-bottom: 0.3rem;
  img {
    width: 100%;
  }
}
.notice {
  width: 8rem !important;
  @media (max-width: 991px) {
    width: 6.86rem !important;
    margin: auto;
    padding: 0;
    .container {
      padding: 0;
    }
  }
  .notice_list {
    width: 100%;
    flex-direction: column;

    .notice-item {
      width: ~"calc(100% - 0.6rem)";
      background: #fff;
      border-radius: 0.2rem;
      padding: 0 0.3rem 0.1rem 0.3rem;
      margin-bottom: 0.3rem;
      text-align: left;
      border-bottom: 0.01rem solid rgba(196, 196, 204, 0.1);
      @media (max-width: 991px) {
        width: 100%;
        padding: 0 0 0.1rem 0;
      }
      .item-style-1 {
        width: 100%;
        flex-direction: column;

        .item-head {
          width: 100%;
          align-items: center;
          justify-content: space-between;
          margin-bottom: 0.2rem;
          display: flex;

          .head-title {
            font-size: 0.2rem;
            color: #1b1c33;
            @media (max-width: 991px) {
              font-size: 0.3rem;
              line-height: 0.4rem;
            }

            img {
              width: 0.54rem;
              height: 0.54rem;
              margin-right: 0.19rem;
            }
          }

          .head-time {
            font-size: 0.14rem;
            color: #8d8e99;
            @media (max-width: 991px) {
              font-size: 0.26rem;
              line-height: 0.33rem;
            }
          }
        }

        .item-content {
          font-size: 0.16rem;
          color: #8d8e99;
          line-height: 0.25rem;
          padding-bottom: 0;
          flex-direction: column;
          @media (max-width: 991px) {
            font-size: 0.26rem;
            line-height: 0.33rem;
          }

          img {
            max-width: 100%;
            margin-bottom: 0.2rem;
          }
          .text {
            font-size: 0.16rem;
            line-height: 0.25rem;
            color: #333;
            @media (max-width: 991px) {
              font-size: 0.26rem;
              line-height: 0.33rem;
            }
          }
        }

        .item-footer {
          cursor: pointer;
          margin-top: 0.2rem;
          display: flex;
          width: 0.8rem;
          justify-content: space-between;
          font-size: 0.16rem;
          height: 0.25rem;
          color: #5e5e66;
          align-items: center;
          @media (max-width: 991px) {
            width: 1.2rem;
          }

          img {
            width: 0.12rem;
            height: 0.22rem;
          }
        }
      }
      .item-style-2 {
        flex-direction: column;
        .item-content {
          width: 6.26rem;
          height: 2.56rem;
          margin-bottom: 0.2rem;
          img {
            width: 100%;
            height: 100%;
          }
        }
        .item-footer {
          justify-content: space-between;
          font-size: 0.3rem;
          height: 0.42rem;
          color: #5e5e66;
          align-items: center;

          img {
            width: 0.17rem;
            height: 0.31rem;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/message/notice.vue